import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import HttpAPICall from '../../services/HttpAPICall';
import { ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import TapIcon from '../../services/TapIcon';
import Status from '../../components/ui/Status';
import { useSelector } from 'react-redux';

const Change2FAModal = ({ modalRef, userDetailData, onSuccess }) => {
    const accessToken                                       = useSelector(state => state.auth.access_token);
    const [save2FAFormSubmitting, setSave2FAFormSubmitting] = useState(false);
    const [twoFAForm, setTwoFAForm]                         = useState({
        enable_2fa: userDetailData?.enable_2fa || 'N'
    });
    useEffect(() => {
        setTwoFAForm({
            enable_2fa: userDetailData?.enable_2fa || 'N'
        });
    }, [userDetailData]);
  const user2FAUrl              =       ORG_API_BASE_URL_2 + '/user/profile/2fa';

  const formInputHandler        =       (e) => {
    setTwoFAForm({
      ...twoFAForm,
      [e.target.name]: e.target.value
    });
  };

  const twoFAFormSubmit         =       (e) => {
    e.preventDefault();
    setSave2FAFormSubmitting(true);
    
    HttpAPICall.withAthorization('PUT', user2FAUrl, accessToken, {}, {
      enable_2fa: twoFAForm.enable_2fa
    }, (response) => {
      toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
      if (modalRef.current) {
        modalRef.current.hide();
      }
      onSuccess?.();
    }).catch(error => {
      toast.error('Failed to update Two Factor Authentication settings.', { position: toast.POSITION.TOP_RIGHT });
    }).finally(() => {
      setSave2FAFormSubmitting(false);
    });
  };

  return (
    <div className="modal fade" id="change2FAModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="change2FAModalLabel">Two Factor Authentication</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className='p-1 bg-light border-bottom'>
            <table className='table table-sm mb-0 table-borderless text-sm'>
              <tbody>
                <tr>
                  <td style={{ width: "26%" }}> Name   </td>
                  <th>{userDetailData ? `${userDetailData.full_name}` : "-"}</th>
                </tr>
                <tr>
                  <td>Role </td><th>{userDetailData && userDetailData.role ? `${userDetailData.role.role} ` : "-"}</th>
                </tr>
                <tr>
                  <td style={{ width: "26%" }}> Status  </td>
                  <th>{userDetailData ? <Status color={userDetailData.status_color_code}>{userDetailData.status_text}</Status> : "-"}</th>
                </tr>
              </tbody>
            </table>
          </div>
          <form onSubmit={twoFAFormSubmit} id="twoFAForm">
            <div className="modal-body">
              <div className="row align-items-center mb-2 mt-2 px-2">
                <div className="col-md-5"><label className="form-label">Two Factor Authentication</label></div>
                <div className="col-md-3">
                  <div className="form-check">
                    <input
                      type="radio"
                      name="enable_2fa"
                      value="Y"
                      onChange={formInputHandler}
                      checked={twoFAForm.enable_2fa === "Y"}
                      className="form-check-input"
                      id="two_fa_yes"
                    />
                    <label className="form-check-label" htmlFor="two_fa_yes">
                      Enable
                    </label>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-check">
                    <input
                      type="radio"
                      name="enable_2fa"
                      value="N"
                      onChange={formInputHandler}
                      checked={twoFAForm.enable_2fa === "N"}
                      className="form-check-input"
                      id="two_fa_no"
                    />
                    <label className="form-check-label" htmlFor="two_fa_no">
                      Disable
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" disabled={save2FAFormSubmitting} data-bs-dismiss="modal">Close</button>
              <button type="submit" className="btn btn-primary" disabled={save2FAFormSubmitting}>
                Save {save2FAFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : null}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Change2FAModal;